import { render, staticRenderFns } from "./Safety2.vue?vue&type=template&id=be50667c&scoped=true"
import script from "./Safety2.vue?vue&type=script&lang=js"
export * from "./Safety2.vue?vue&type=script&lang=js"
import style0 from "./Safety2.vue?vue&type=style&index=0&id=be50667c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be50667c",
  null
  
)

export default component.exports